export default "<ion-icon (click)=\"presentPopover($event)\" [name]=\"visible ? 'close' : 'menu-sharp'\" class=\"white\" size=\"large\"></ion-icon>\n";